module.exports = new __parcel__URL__("collaborate.2fea736c.svg").toString();